import {Injectable} from '@angular/core';
import {get} from 'lodash';
import {StakeholdersDaoService} from '../stakeholders-dao.service';

import {GridStrategy} from './models/interfaces';

@Injectable({
  providedIn: 'root'
})
export class StakeholderGridStrategyService implements GridStrategy {
  constructor(private readonly shDaoService: StakeholdersDaoService) {}

  public getItems({rmId, options, isSf, query}) {
    query.type = get(options, 'data.typeFilter', '');

    return isSf
      ? this.shDaoService.getUserSfNodes(rmId, query)
      : this.shDaoService.getUserRefNodes(rmId, query);
  }

  public getParentId(parentId: string, refModelId: string): string | null {
    return parentId || null;
  }
}
